import styled from '@emotion/styled';

export const WorkspacesContent = styled.div`
  height: 100vh;
  display: flex;
  align-items: center;
`;
